<div class="skeleton-main" [ngStyle]="{ height: height, width: width }">
    <div class="squire skeleton"></div>
</div>
